import { useParams } from 'react-router';

const AREAS: Record<string, { title: string; text: string }> = {
  configuracoes: {
    title: 'Configurações gerais',
    text: 'Perfil de preço da loja, regras em camadas, estoque de segurança e dados da empresa.',
  },
};

export function ComingSoon() {
  const { area = '' } = useParams();
  const a = AREAS[area] ?? { title: 'Em breve', text: 'Esta área ainda está em construção.' };
  return (
    <>
      <div className="page-head"><div><h1>{a.title}</h1></div></div>
      <div className="panel empty"><b>Em construção</b>{a.text}</div>
    </>
  );
}
